import { FC } from "react";
import { Divider } from "antd";
import classNames from "classnames";
import SkeletonBox from "src/components/SkeletonBox/SkeletonBox";

const FlightsSkeleton: FC<{ className?: string }> = ({ className }) => {
  return (
    <div
      className={classNames(
        "flex w-full items-stretch rounded-2xl outline outline-border-default bg-background-default py-4 px-4 gap-2",
        className
      )}
    >
      <div className="flex flex-[7] flex-col gap-4 py-2 min-w-0">
        <div className="flex items-center justify-between gap-4 px-2 md:px-5">
          <div className="flex items-center gap-2 md:gap-3 min-w-0">
            <SkeletonBox className="h-7 w-7 md:h-14 md:w-14 shrink-0 rounded-none" />
            <SkeletonBox className="h-4 flex-1 md:h-5" />
          </div>
          <div className="flex shrink-0 gap-1.5">
            <SkeletonBox className="h-6 w-16 md:h-8 md:w-24 rounded-md" />
            <SkeletonBox className="h-6 w-14 md:h-8 md:w-20 rounded-md" />
          </div>
        </div>

        <div className="flex items-center gap-3 px-4 md:px-8">
          <div className="flex shrink-0 flex-col items-start gap-1">
            <SkeletonBox className="h-4 w-12 md:h-5" />
            <SkeletonBox className="h-2.5 w-8 md:h-3" />
          </div>
          <SkeletonBox className="h-0.5 flex-1 rounded-full" />
          <div className="flex shrink-0 flex-col items-end gap-1">
            <SkeletonBox className="h-4 w-12 md:h-5" />
            <SkeletonBox className="h-2.5 w-8 md:h-3" />
          </div>
        </div>

        <Divider className="m-1!" />

        <div className="flex items-center justify-between gap-4 px-2 md:px-5">
          <div className="flex flex-1 flex-wrap gap-3 md:gap-5 min-w-0">
            <SkeletonBox className="h-4 flex-1 md:h-5 rounded-sm" />
          </div>
          <SkeletonBox className="h-7 shrink-0 w-20 md:h-8 md:w-28 rounded-md" />
        </div>
      </div>

      <Divider orientation="vertical" className="h-auto! self-stretch!" />

      <div className="flex flex-[2] flex-col items-center justify-center gap-3 md:gap-4 min-w-0">
        <div className="flex w-full flex-col items-center gap-2">
          <SkeletonBox className="h-5 w-3/4 md:h-6" />
          <SkeletonBox className="h-4 w-1/2 md:h-5" />
        </div>
        <SkeletonBox className="h-7 w-4/5 md:h-8 rounded-md" />
      </div>
    </div>
  );
};

export default FlightsSkeleton;
